import React from 'react'

const fullName = 'Sharifu .H. Masudi';

const copyFullYear = new Date().getFullYear();

const Footer = () => {
  return (
   <div>
     <footer className="footer">
      <div className="container text-center"></div>
      <div className="h4 title text-center">{fullName}</div>
      <div className="text-center text-muted">
        <p>&copy; {copyFullYear}. All rights reserved.<br/></p>
      </div>
  </footer>
   </div>
  )
}

export default Footer
